import request from "@/utils/request";
const BASE_URL = "/EquipmentDatathreshold";

//类别
export default {
  list(data) {
    return request({
      url: BASE_URL + "/List",
      method: "post",
      data,
    });
  },
  info(id) {
    return request({
      url: BASE_URL + "/Info",
      method: "get",
      params: { id },
    });
  },
  save(data) {
    return request({
      url: BASE_URL + "/Save",
      method: "post",
      data,
    });
  },
  
  
  
};
